import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { useSearchParamsModal } from '../../../../../../components/modal/useSearchParamsModal';

import { Column } from '../../../../../../components/grid/Grid';
import { SearchModal } from '../../components/search-modal/SearchModal';
import { SearchQuerySectionCommentaries } from '../../components/search-query-section/commentaries/SearchQuerySectionCommentaries';

import { LegislationContextType } from '../../../../legislation.types';

import { transformCount } from '../../utils/utils';

type Props = {
  commentaries: LegislationContextType['commentaries'];
  articleTitle: string;
  articleIds: string[];
  articleId: string;
  textNature: string;
  textId: string;
  initialVersionId: string;
};

export const Commentaries: FC<Props> = ({
  commentaries,
  articleIds,
  articleTitle,
  articleId,
  textNature,
  textId,
  initialVersionId,
}) => {
  useSearchParamsModal('commentaries-search', (modalProps) => (
    <SearchModal
      restrictedIds={articleIds}
      title={articleTitle}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...modalProps}
    />
  ));

  if (!commentaries.data) return null;

  return (
    <>
      <Column medium={4}>
        <h2>
          <FormattedMessage
            id="page/sections/commentaries/Commentaries.tsx/1"
            values={{
              count: transformCount(commentaries.data.totalHits),
            }}
          />
        </h2>
      </Column>
      <Column medium={8}>
        <SearchQuerySectionCommentaries
          articleTitle={articleTitle}
          articleIds={articleIds}
          articleId={articleId}
          textNature={textNature}
          commentaries={commentaries}
          textId={textId}
          initialVersionId={initialVersionId}
        />
      </Column>
    </>
  );
};
